export { CELL_TYPE, CheckboxCellType } from "./checkboxType.mjs";


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/cellTypes/checkboxType/index.mjs
// module id = 1093
// module chunks = 1